module.exports = __webpack_public_path__ + "media/placeholder-images/placeholder_12-82ec1cb5.jpg";